import React, { useState } from "react";
import "./MyLoginPages.scss";
import {
  LoginForm,
  ResetPasswordForm,
  ChangePasswordForm,
} from "../../components";
import OtpForm from "../../components/otp-form/OtpForm";
import logo from "../../assets/tickety.png";
import logo2 from "../../assets/image.png";
import RequestPwdForm from "../../components/request-pwd-form/RequestPwdForm";
import RegistrationForm from "../../components/registrationForm/RegistrationForm";
import SetPassword from "../../components/registrationForm/SetPassword";
import QitLogo from "../../assets/QitLogo.svg";
import LoginBG from "../../assets/loginPageSidePhoto.png";

export default function MyLoginPages() {
  const [showForgotPwd, setShowForgotPwd] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
  const [showReqAdminForm, setShowReqAdminForm] = useState(false);
  const [otpRole, setOtpRole] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [registerRole, setRegisterRole] = useState("");

  const handleOtpContinue = (email, newRole, userRole) => {
    setEmailOtp(email);
    setOtpRole(newRole);
    setRegisterRole(userRole); // new role for registration
    setShowOtpForm(true);
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPwd(true);
  };

  const onResetPwdGoBack = () => {
    setShowForgotPwd(false);
    setShowOtpForm(false);
    setShowChangePasswordForm(false);
  };

  const onOtpFormGoBack = () => {
    setShowOtpForm(false);
    setShowChangePasswordForm(false);

    if (showRegisterForm) {
      setShowRegisterForm(true);
      setShowForgotPwd(false);
    } else {
      setShowForgotPwd(true);
    }
  };

  // const handleOtpVerified = (verified) => {
  //   if (verified) {
  //     // Register Flow
  //     if (showRegisterForm) {
  //       setShowOtpForm(false);
  //       setShowSetPassword(true);
  //       return;
  //     }

  //     if (otpRole === "company") {
  //       setShowChangePasswordForm(true);
  //     } else {
  //       setShowOtpForm(false);
  //       setShowForgotPwd(false);
  //       setShowChangePasswordForm(false);
  //       setShowReqAdminForm(true);
  //     }
  //   }
  // };
  const handleOtpVerified = (verified) => {
    if (verified) {
      setShowOtpForm(false);
      setShowForgotPwd(false);
      setShowRegisterForm(false);
      setShowSetPassword(true);
    }
  };

  const onChangePwdGoBack = () => {
    setShowForgotPwd(false);
    setShowOtpForm(true);
    setShowChangePasswordForm(false);
  };

  const onReqPwdFormGoBack = () => {
    setShowOtpForm(true);
    setShowForgotPwd(false);
    setShowChangePasswordForm(false);
    setShowReqAdminForm(false);
  };

  const handleRegisterClick = () => {
    setShowRegisterForm(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPwd(false);
    setShowOtpForm(false);
    setShowChangePasswordForm(false);
    setShowReqAdminForm(false);
    setShowRegisterForm(false);
    setShowSetPassword(false);
  };

  return (
    <div className="mainPart">
      <div className="rightPart">
        <img src={LoginBG} alt="right" />
      </div>
      <div className="leftPart">
        <div className="innerPart dx-card responsive-paddings">
          <div className="company-logo">
            <img src={QitLogo} alt="Company Logo" />
          </div>
          <div className="product img">
            <img src={logo2} alt="Tickety Logo" />
            {/* <span className="qit">By Quantum IT Solution</span> */}
          </div>

          {/* Login Form */}
          {!showForgotPwd &&
            !showOtpForm &&
            !showChangePasswordForm &&
            !showReqAdminForm &&
            !showRegisterForm &&
            !showSetPassword && (
              <LoginForm
                onForgotPassword={handleForgotPasswordClick}
                onRegisterClick={handleRegisterClick}
              />
            )}

          {/* Reset Password Form */}
          {showForgotPwd &&
            !showOtpForm &&
            !showChangePasswordForm &&
            !showReqAdminForm && (
              <ResetPasswordForm
                onContinue={handleOtpContinue}
                onResetPwdGoBack={onResetPwdGoBack}
              />
            )}

          {/* OTP Form */}
          {showOtpForm && !showChangePasswordForm && !showReqAdminForm && (
            <OtpForm
              emailOtp={emailOtp}
              onOtpFormGoBack={onOtpFormGoBack}
              onOtpVerified={handleOtpVerified}
              action={showRegisterForm ? "C" : "R"}
              onRegisterOtpVerified={() => {
                setShowOtpForm(false);
                setShowSetPassword(true);
              }}
            />
          )}

          {/* Request Admin Form */}
          {showReqAdminForm && !showChangePasswordForm && (
            <RequestPwdForm
              emailOtp={emailOtp}
              otpRole={otpRole}
              onReqPwdFormGoBack={onReqPwdFormGoBack}
            />
          )}

          {/* Change Password Form */}
          {showChangePasswordForm &&
            !showReqAdminForm &&
            otpRole === "company" && (
              <ChangePasswordForm
                emailOtp={emailOtp}
                onChangePwdGoBack={onChangePwdGoBack}
              />
            )}

          {/* Register Form */}
          {showRegisterForm &&
            !showOtpForm &&
            !showChangePasswordForm &&
            !showReqAdminForm &&
            !showSetPassword && (
              <RegistrationForm
                onContinue={handleOtpContinue}
                onResetPwdGoBack={() => setShowRegisterForm(false)}
              />
            )}

          {showSetPassword && !showForgotPwd && !showOtpForm && (
            <SetPassword
              emailOtp={emailOtp}
              role={registerRole}
              action={showRegisterForm ? "C" : "R"}
              onChangePwdGoBack={() => {
                setShowSetPassword(false);
                setShowOtpForm(true);
              }}
              onPasswordSaved={handleBackToLogin}
            />
          )}
        </div>
      </div>
    </div>
  );
}
